import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Home } from 'lucide-react';
import { Helmet } from 'react-helmet-async';

export default function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>Side ikke fundet | Dilling El</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <main data-testid="not-found-page" className="pt-24 min-h-screen bg-[#F4F2EE] flex items-center">
        <div className="max-w-[1400px] mx-auto px-8 md:px-16 lg:px-24 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="text-[#A6B8A2] text-8xl md:text-9xl font-['Cormorant_Garamond'] font-light">
              404
            </span>
            <h1 className="font-['Cormorant_Garamond'] text-3xl md:text-4xl font-medium text-[#0E3D24] mt-6">
              Siden blev ikke fundet
            </h1>
            <p className="text-[#1E2A24]/70 mt-4 max-w-md mx-auto">
              Den side, du leder efter, findes ikke eller er blevet flyttet.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center mt-10">
              <Link 
                to="/"
                className="inline-flex items-center justify-center gap-3 bg-[#0E3D24] text-white px-8 py-4 text-sm tracking-[0.05em] transition-all duration-300 hover:bg-[#1F5A3A] group"
              >
                <Home size={16} />
                <span>Til forsiden</span>
              </Link>
              <Link 
                to="/kontakt"
                className="inline-flex items-center justify-center gap-3 border border-[#0E3D24] text-[#0E3D24] px-8 py-4 text-sm tracking-[0.05em] transition-all duration-300 hover:bg-[#0E3D24] hover:text-white group"
              >
                <span>Kontakt os</span>
                <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
          </motion.div>
        </div>
      </main>
    </>
  );
}
